import React from 'react';
import { ErrorPage } from './errorPage'

export const PageNotFound = () => {
    return <ErrorPage
        title='Page Not Found'
    >
        The requested page was not found.
    </ErrorPage>
}